import { Translations } from '../../../shared/i18n/Translations'
import { IDB_locationKeysReadAll } from '../IDB/IDB.table.location'
import { UI_dialogOk } from '../UI/UI.Dialog'

export const Loca_getSingleLocation = async (
    deps: {
        IDB_locationKeysReadAll: typeof IDB_locationKeysReadAll
        UI_dialogOk: typeof UI_dialogOk
    } = {
        IDB_locationKeysReadAll,
        UI_dialogOk,
    }
) => {
    const locationIds = await deps.IDB_locationKeysReadAll()

    if (locationIds.length === 0) {
        deps.UI_dialogOk(Translations.t('app:UI.common.somethingWentWrong'), youDontHaveLocations())
        throw new Error('No locations exist')
    }

    return locationIds[0]
}

const youDontHaveLocations = () => Translations.t('app:Todo.ToDoPage.noLocation')
